import React, { useState, useEffect } from "react";
import axios from "axios";
import hdfc from "../../images/bank1.png";
import { IoMdClose } from "react-icons/io";
import SuccessImage from "../../images/sidebar/SuccessImage";
import ImageLoading from "../../components/ImageLoading";

const BsaModal = ({
  setOpenBsa,
  detailId,
  bankName,
  image,
  setNoDownloadData,
}) => {
  const [selectedDownload, setSelectedDownload] = useState("");
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [succesState, setSuccesState] = useState(false);
  const handleExcelDownload2 = async (recordItem) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/bank_analysis?bank_detail_id=${recordItem}&data_required=all&download=true`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.error) {
        setNoDownloadData(true);
        return;
      }
      if (res.data.url.status) {
        const url = res.data.url.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleExcelDownload3 = async (recordItem) => {
    setDownloadLoading(true);
    const token = localStorage.getItem("token");
    try {
      const options = {
        url: `${process.env.REACT_APP_URL}/lender/v1/users/bank_analysis?bank_detail_id=${recordItem}&data_required=all&download=true&request_type=v1`,
        method: "GET",
        headers: { Authorization: token },
      };
      const res = await axios(options);
      // console.log(res);
      if (res.data.error) {
        setNoDownloadData(true);
        return;
      }
      if (res.data.url.status) {
        const url = res.data.url.data;

        handleDownloadFile(url);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDownloadLoading(false);
    }
  };
  const handleDownloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", ""); // 'download' attribute triggers download
    document.body.appendChild(link);
    link.click();
    link.remove();
    setSuccesState(true);
    setTimeout(() => {
      setOpenBsa(false);
    }, 3000);
  };
  const handleBsaDownload = (type) => {
    if (selectedDownload === type) {
      setSelectedDownload("");
      return;
    }
    setSelectedDownload(type);
  };

  return (
    <div className="overlay z-50">
      <div className={`modal !w-[320px]  !h-[253px] !p-0 !text-left `}>
        {!succesState && !downloadLoading && (
          <div className=" w-fullh-full p-6 flex flex-col">
            <div className=" flex justify-between">
              <p className=" text-base font-bold w">
                Download Bank Statement Analyzer (BSA){" "}
              </p>
              <p
                className=" cursor-pointer"
                onClick={() => {
                  setOpenBsa(false);
                }}
              >
                <IoMdClose className=" w-[20px] h-[20px]" />
              </p>
            </div>
            <p className=" flex items-center mt-4 text-xs font-bold">
              {true && (
                <div className="bg-[#f0f9ff] rounded-full mr-[10px] w-8 h-8 flex items-center justify-center">
                  <img
                    src={image ? image : hdfc}
                    alt=""
                    width={27}
                    height={27}
                    className="  object-cover"
                  />
                </div>
              )}
              {bankName || "---"}
            </p>
            <p className=" text-xs mt-4 font-semibold text-[#6f6f6f]">
              Select a file to download
            </p>
            <div className=" mt-3 flex items-center">
              <button
                className={` py-[4px] px-[10px] text-xs font-semibold  ${
                  selectedDownload === "old_bsa"
                    ? "bg-[#a0ff77] text-[#262626]"
                    : "bg-[#f1f1f8] text-[#848484]"
                } rounded-2xl cursor-pointer`}
                onClick={() => handleBsaDownload("old_bsa")}
              >
                Old BSA
              </button>
              <button
                onClick={() => handleBsaDownload("new_bsa")}
                className={` ml-[18px] py-[4px] px-[10px] text-xs font-semibold  ${
                  selectedDownload === "new_bsa"
                    ? "bg-[#a0ff77] text-[#262626]"
                    : "bg-[#f1f1f8] text-[#848484]"
                }   rounded-2xl cursor-pointer`}
              >
                New BSA
              </button>
            </div>
            <button
              className=" mt-4 ml-auto mr-auto bg-[#00394d] w-[100px] h-[32px] rounded text-white text-sm font-semibold"
              onClick={() => {
                if (selectedDownload === "old_bsa") {
                  handleExcelDownload2(detailId);
                  return;
                }
                if (selectedDownload === "new_bsa") {
                  handleExcelDownload3(detailId);
                }
              }}
            >
              Download
            </button>
          </div>
        )}

        {succesState && !downloadLoading && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            <SuccessImage />
            <p className=" font-bold  text-base mt-2">Download, successful!</p>
          </div>
        )}
        {downloadLoading && (
          <div className=" w-full h-full flex justify-center flex-col items-center">
            <ImageLoading />
          </div>
        )}
      </div>
    </div>
  );
};

export default BsaModal;
